import React from 'react';
import { NewOrderDialog } from '@/components/project/orders/NewOrderDialog';
import { OrderDetailDialog } from '@/components/project/orders/OrderDetailDialog';
import { EditOrderDialog } from '@/components/project/orders/EditOrderDialog';
import { TemplatePickerDialog } from '@/components/project/orders/TemplatePickerDialog';
import { SaveAsTemplateDialog } from '@/components/project/orders/SaveAsTemplateDialog';
import { DuplicateOrderDialog } from '@/components/project/orders/DuplicateOrderDialog';

const OrderDialogs = (props) => (
  <>
    <NewOrderDialog
      showNewOrder={props.showNewOrder}
      setShowNewOrder={props.setShowNewOrder}
      newOrder={props.newOrder}
      setNewOrder={props.setNewOrder}
      setVendorSearch={props.setVendorSearch}
      showVendorSuggestions={props.showVendorSuggestions}
      setShowVendorSuggestions={props.setShowVendorSuggestions}
      vendorSuggestions={props.vendorSuggestions}
      newOrderSubtotal={props.newOrderSubtotal}
      newOrderTotal={props.newOrderTotal}
      handleCreateOrder={props.handleCreateOrder}
      addLineItem={props.addLineItem}
      removeLineItem={props.removeLineItem}
      moveLineItem={props.moveLineItem}
      updateLineItem={props.updateLineItem}
      updateLineItemFields={props.updateLineItemFields}
      fetchBenchmark={props.fetchBenchmark}
      getPriceIndicator={props.getPriceIndicator}
      priceBenchmarks={props.priceBenchmarks}
      phases={props.phases}
      onOpenProductDetail={props.onOpenProductDetail}
      formatCurrency={props.formatCurrency}
    />
    <OrderDetailDialog
      showOrderDetail={props.showOrderDetail}
      setShowOrderDetail={props.setShowOrderDetail}
      attachments={props.attachments}
      uploading={props.uploading}
      handleUpdateOrderStatus={props.handleUpdateOrderStatus}
      handleDownloadPDF={props.handleDownloadPDF}
      handleUploadAttachment={props.handleUploadAttachment}
      handleDeleteAttachment={props.handleDeleteAttachment}
      openEditOrder={props.openEditOrder}
      openSaveAsTemplate={props.openSaveAsTemplate}
      setDuplicateTarget={props.setDuplicateTarget}
      setConfirmDelete={props.setConfirmDelete}
      canManageTeam={props.canManageTeam}
      phases={props.phases}
      formatCurrency={props.formatCurrency}
      formatDate={props.formatDate}
      formatFileSize={props.formatFileSize}
      getOrderStatusClass={props.getOrderStatusClass}
    />
    <EditOrderDialog
      showEditOrder={props.showEditOrder}
      setShowEditOrder={props.setShowEditOrder}
      editOrderSubtotal={props.editOrderSubtotal}
      editOrderTotal={props.editOrderTotal}
      handleSaveEditOrder={props.handleSaveEditOrder}
      phases={props.phases}
      formatCurrency={props.formatCurrency}
    />
    <TemplatePickerDialog
      showTemplatesPicker={props.showTemplatesPicker}
      setShowTemplatesPicker={props.setShowTemplatesPicker}
      orderTemplates={props.orderTemplates}
      applyOrderTemplate={props.applyOrderTemplate}
      formatCurrency={props.formatCurrency}
    />
    <SaveAsTemplateDialog
      saveAsTemplate={props.saveAsTemplate}
      setSaveAsTemplate={props.setSaveAsTemplate}
      savingTemplate={props.savingTemplate}
      handleSaveAsTemplate={props.handleSaveAsTemplate}
      formatCurrency={props.formatCurrency}
    />
    <DuplicateOrderDialog
      duplicateTarget={props.duplicateTarget}
      setDuplicateTarget={props.setDuplicateTarget}
      duplicating={props.duplicating}
      handleDuplicateOrder={props.handleDuplicateOrder}
      companyProjects={props.companyProjects}
      formatCurrency={props.formatCurrency}
    />
  </>
);

export default OrderDialogs;
